import { render, staticRenderFns } from "./MontagemCarga.vue?vue&type=template&id=231f8adc&scoped=true"
import script from "./MontagemCarga.vue?vue&type=script&lang=js"
export * from "./MontagemCarga.vue?vue&type=script&lang=js"
import style0 from "./MontagemCarga.vue?vue&type=style&index=0&id=231f8adc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f8adc",
  null
  
)

export default component.exports